import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { NiceAsyncTypeaheadModule, NiceTransformResponseInterceptor } from "@recursyve/nice-ui-kit.v2";
import { SessionApi } from "./auth/session.api";
import { CacheApi } from "./cache/cache.api";
import { InfoApi } from "./info/info.api";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { LanguageInterceptor } from "./interceptors/language.interceptor";
import { AccountCreationCodesApi } from "./nerri/accounts/apis/account-creation-codes.api";
import { AccountsTypeaheadApi } from "./nerri/accounts/apis/accounts-typeahead.api";
import { AccountsApi } from "./nerri/accounts/apis/accounts.api";
import { ActionItemsApi } from "./nerri/action-items/apis/action-items.api";
import { AddressesApi } from "./nerri/addresses/apis/addresses.api";
import { AnalysisSamplesApi } from "./nerri/analysis-samples/apis/analysis-samples.api";
import { AnnouncementsApi } from "./nerri/announcements/announcements.api";
import { ConstantsApi } from "./nerri/constants/constants.api";
import { ContractorsApi } from "./nerri/contractors/contractors.api";
import { ContractorsTypeaheadApi } from "./nerri/contractors/typeaheads/contractors-typeahead.api";
import { LaboratoriesApi } from "./nerri/laboratories/apis/laboratories.api";
import { OrganisationLaboratoriesApi } from "./nerri/laboratories/apis/organisation-laboratories.api";
import { MaintenanceContractsApi } from "./nerri/maintenance-contracts/apis/maintenance-contracts.api";
import { MaintenanceVisitsApi } from "./nerri/maintenance-visits/apis/maintenance-visits.api";
import { OrganisationsContactsApi } from "./nerri/organisation-contacts/organisation-contacts.api";
import { OrganisationsApi } from "./nerri/organisations/organisations.api";
import { OwnersApi } from "./nerri/owners/owners.api";
import { OccupationsTypeaheadApi } from "./nerri/properties/apis/enums/occupations-typeahead.api";
import { OccupationsApi } from "./nerri/properties/apis/enums/occupations.api";
import { PropertiesApi } from "./nerri/properties/apis/properties.api";
import { PumpingContractConfirmationCodesApi } from "./nerri/pumping-contracts/apis/pumping-contract-confirmation-codes.api";
import { PumpingContractApi } from "./nerri/pumping-contracts/apis/pumping-contract.api";
import { FuelTypesApi } from "./nerri/pumping-trucks/apis/fuel-types.api";
import { PumpingTruckTypesApi } from "./nerri/pumping-trucks/apis/pumping-truck-types.api";
import { PumpingTrucksTypeaheadApi } from "./nerri/pumping-trucks/apis/pumping-trucks-typeahead.api";
import { PumpingTrucksApi } from "./nerri/pumping-trucks/apis/pumping-trucks.api";
import { PumpingVisitBillingTypesApi } from "./nerri/pumping-visits/apis/pumping-visit-billing-types.api";
import { PumpingVisitTypesApi } from "./nerri/pumping-visits/apis/pumping-visit-types.api";
import { PumpingVisitsApi } from "./nerri/pumping-visits/apis/pumping-visits.api";
import { PumpingVisitBillingTypesTypeaheadApi } from "./nerri/pumping-visits/apis/typeaheads/pumping-visit-billing-types-typeahead.api";
import { PumpingVisitTypesTypeaheadApi } from "./nerri/pumping-visits/apis/typeaheads/pumping-visit-types-typeahead.api";
import { RolesApi } from "./nerri/roles/roles.api";
import { SanitaryReportVisitsApi } from "./nerri/sanitary-report-visits/apis/sanitary-report-visits.api";
import { SectorsApi } from "./nerri/sectors/apis/sectors.api";
import { SeptageMeasurementVisitsApi } from "./nerri/septage-measurement-visits/apis/septage-measurement-visits.api";
import { SectorsTypeaheadApi } from "./nerri/sectors/apis/typeaheads/sectors-typeahead.api";
import { SharedFilesApi } from "./nerri/shared-files/shared-files.api";
import { StorageApi } from "./nerri/storage/storage.api";
import { AdvancedSystemManufacturersApi } from "./nerri/system-channels/apis/advanced-system-manufacturers.api";
import { AdvancedSystemTypesApi } from "./nerri/system-channels/apis/advanced-system-types.api";
import { AdvancedSystemsApi } from "./nerri/system-channels/apis/avanced-systems.api";
import { PrimarySystemMaterialsApi } from "./nerri/system-channels/apis/enums/primary-system-materials.api";
import { PrimarySystemTypesApi } from "./nerri/system-channels/apis/enums/primary-system-types.api";
import { SecondarySystemTypesApi } from "./nerri/system-channels/apis/enums/secondary-system-types.api";
import { PrimarySystemsApi } from "./nerri/system-channels/apis/primary-system.api";
import { SecondarySystemsApi } from "./nerri/system-channels/apis/secondary-systems.api";
import { SystemChannelPumpingSchedulesApi } from "./nerri/system-channels/apis/system-channel-pumping-schedules.api";
import { SystemChannelsApi } from "./nerri/system-channels/apis/system-channels.api";
import { AdvancedSystemManufacturersTypeaheadApi } from "./nerri/system-channels/typeaheads/advanced-system-manufacturers-typeahead.api";
import { AdvancedSystemTypesTypeaheadApi } from "./nerri/system-channels/typeaheads/advanced-system-types-typeahead.api";
import { PrimarySystemMaterialsTypeaheadApi } from "./nerri/system-channels/typeaheads/primary-system-materials-typeahead.api";
import { PrimarySystemTypesTypeaheadApi } from "./nerri/system-channels/typeaheads/primary-system-types-typeahead.api";
import { SecondarySystemTypesTypeaheadApi } from "./nerri/system-channels/typeaheads/secondary-system-types-typeahead.api";
import { UnitsApi } from "./nerri/units/apis/units.api";

@NgModule({
    imports: [
        NiceAsyncTypeaheadModule.register([
            AccountsTypeaheadApi,
            AdvancedSystemManufacturersTypeaheadApi,
            AdvancedSystemTypesTypeaheadApi,
            ContractorsTypeaheadApi,
            OccupationsTypeaheadApi,
            PrimarySystemMaterialsTypeaheadApi,
            PrimarySystemTypesTypeaheadApi,
            PumpingTrucksTypeaheadApi,
            PumpingVisitBillingTypesTypeaheadApi,
            PumpingVisitTypesTypeaheadApi,
            SecondarySystemTypesTypeaheadApi,
            SectorsTypeaheadApi
        ])
    ],
    providers: [
        AccountCreationCodesApi,
        AccountsApi,
        ActionItemsApi,
        AddressesApi,
        AdvancedSystemManufacturersApi,
        AdvancedSystemTypesApi,
        AdvancedSystemsApi,
        AnalysisSamplesApi,
        AnnouncementsApi,
        CacheApi,
        ConstantsApi,
        ContractorsApi,
        FuelTypesApi,
        InfoApi,
        LaboratoriesApi,
        MaintenanceContractsApi,
        MaintenanceVisitsApi,
        OccupationsApi,
        OrganisationLaboratoriesApi,
        OrganisationsApi,
        OrganisationsContactsApi,
        OwnersApi,
        PrimarySystemMaterialsApi,
        PrimarySystemTypesApi,
        PrimarySystemsApi,
        PropertiesApi,
        PumpingContractApi,
        PumpingContractConfirmationCodesApi,
        PumpingTruckTypesApi,
        PumpingTrucksApi,
        PumpingVisitBillingTypesApi,
        PumpingVisitTypesApi,
        PumpingVisitsApi,
        RolesApi,
        SanitaryReportVisitsApi,
        SecondarySystemTypesApi,
        SecondarySystemsApi,
        SectorsApi,
        SeptageMeasurementVisitsApi,
        SessionApi,
        SharedFilesApi,
        StorageApi,
        SystemChannelPumpingSchedulesApi,
        SystemChannelsApi,
        UnitsApi,
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: NiceTransformResponseInterceptor, multi: true }
    ]
})
export class ApiModule {}
